import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getList = async (params: object) => {
  return await POST({ url: Api.getList, data: params, showError: false })
}
